/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import EditFaq from "./EditFaq.container";

export default EditFaq;
